import {
  CustomForm,
  CustomFormTemplate,
  FpCompany, PublicLinkObjectType,
  User
} from '@flicent/fieldpulse-react-component-library-frontend';

import { ApiServiceInstance } from './Api.service';


interface RequestParams {
  templateId: number;
  token: string;
  objectType: PublicLinkObjectType;
  objectId: number;
}

interface ResponseDataType extends CustomFormTemplate {
  can_manage_form_files: boolean;
  user: User;
  company: FpCompany;
  form: CustomForm;
}

export const initCustomFormCreationRequest = ({
                                                templateId,
                                                token,
                                                objectId,
                                                objectType,
                                              }: RequestParams): Promise<ResponseDataType> => {
  return ApiServiceInstance.makeRequest(`/custom-form/init-create`, {
    method: 'POST',
    token,
    body: {
      template_id: templateId,
      object_id: objectId,
      object_type: objectType,
    },
  });
};